/* eslint-disable no-unused-vars */
import { IGetApiRequestParams, ILooseObject } from '@/src/types/common.interface';
import AppUtils from '@/src/utils/AppUtils';

export enum ALL_ROLES_API_URLS_ENUM {
  GET_ALL_ROLES_LIST = 'GET_ALL_ROLES_LIST',
  GET_ALL_GRAPH_ROLES_LIST = 'GET_ALL_GRAPH_ROLES_LIST',
  UPDATE_NODES_EDGES_HIERARCHY = 'UPDATE_NODES_EDGES_HIERARCHY',
  GET_ROLES_DETAILS = 'GET_ROLES_DETAILS',
  GET_ALL_APPLICATIONS = 'GET_ALL_APPLICATIONS',
  GET_ALL_PERMISSIONS = 'GET_ALL_PERMISSIONS',
  GET_ALL_POLICIES = 'GET_ALL_POLICIES',
  GET_ALL_USERS_BY_ROLE = 'GET_ALL_USERS_BY_ROLE',
  POST_UPDATE_ROLES = 'POST_UPDATE_ROLES',
  ADD_ROLE_TO_APPLICATION = 'ADD_ROLE_TO_APPLICATION',
  ADD_ROLE_TO_ORGANIZATION = 'ADD_ROLE_TO_ORGANIZATION',
  ADD_PERMISSION_TO_ROLE_BY_APPLICATION = 'ADD_PERMISSION_TO_ROLE_BY_APPLICATION',
  REMOVE_PERMISSION_TO_ROLE_BY_APPLICATION = 'REMOVE_PERMISSION_TO_ROLE_BY_APPLICATION'
}

type GET_ALL_ROLES_API_URL_TYPE = IGetApiRequestParams & {
  url: ALL_ROLES_API_URLS_ENUM;
  data?: ILooseObject;
};

abstract class AllRolesApiConfig {
  public static GetAllRolesApiUrl({ url, filters, pagination, data }: GET_ALL_ROLES_API_URL_TYPE) {
    switch (url) {
      case ALL_ROLES_API_URLS_ENUM.GET_ALL_ROLES_LIST:
        return AppUtils.formatGetApiParameters(
          `${process.env.REACT_APP_CENTRAL_AUTH_API_BASE_URL}/v1/roles`,
          { pagination, filters }
        );

      case ALL_ROLES_API_URLS_ENUM.GET_ALL_GRAPH_ROLES_LIST:
        return AppUtils.formatGetApiParameters(
          `${process.env.REACT_APP_CENTRAL_AUTH_API_BASE_URL}/v1/roles/graph`,
          { pagination, filters }
        );

      case ALL_ROLES_API_URLS_ENUM.GET_ROLES_DETAILS:
        return `${process.env.REACT_APP_CENTRAL_AUTH_API_BASE_URL}/v1/roles/${data?.roleKey}`;

      case ALL_ROLES_API_URLS_ENUM.GET_ALL_APPLICATIONS:
        return `${process.env.REACT_APP_CENTRAL_AUTH_API_BASE_URL}/v1/applications`;

      case ALL_ROLES_API_URLS_ENUM.GET_ALL_PERMISSIONS:
        return `${process.env.REACT_APP_CENTRAL_AUTH_API_BASE_URL}/v1/${data?.applicationKey}/permissions`;

      case ALL_ROLES_API_URLS_ENUM.GET_ALL_POLICIES:
        return `${process.env.REACT_APP_CENTRAL_AUTH_API_BASE_URL}/v1/application/${data?.applicationKey}/policy`;

      case ALL_ROLES_API_URLS_ENUM.GET_ALL_USERS_BY_ROLE:
        return `${process.env.REACT_APP_CENTRAL_AUTH_API_BASE_URL}/v2/users/${data?.roleKey}`;

      case ALL_ROLES_API_URLS_ENUM.POST_UPDATE_ROLES:
        return `${process.env.REACT_APP_CENTRAL_AUTH_API_BASE_URL}/v1/user/${data?.userKey}/roles/mapping?v=${data?.version}`;

      case ALL_ROLES_API_URLS_ENUM.ADD_ROLE_TO_APPLICATION:
        return `${process.env.REACT_APP_CENTRAL_AUTH_API_BASE_URL}/v1/application/${data?.applicationKey}/roles`;

      case ALL_ROLES_API_URLS_ENUM.ADD_ROLE_TO_ORGANIZATION:
        return `${process.env.REACT_APP_CENTRAL_AUTH_API_BASE_URL}/v1/organization/${data?.organizationKey}/roles`;

      case ALL_ROLES_API_URLS_ENUM.REMOVE_PERMISSION_TO_ROLE_BY_APPLICATION:
      case ALL_ROLES_API_URLS_ENUM.ADD_PERMISSION_TO_ROLE_BY_APPLICATION:
        return AppUtils.formatGetApiParameters(
          `${process.env.REACT_APP_CENTRAL_AUTH_API_BASE_URL}/v1/application/${data?.applicationKey}/roles/${data?.roleKey}/permissions`,
          { filters }
        );

      case ALL_ROLES_API_URLS_ENUM.UPDATE_NODES_EDGES_HIERARCHY:
        return `${process.env.REACT_APP_CENTRAL_AUTH_API_BASE_URL}/v1/role/hierarchy/${data?.applicationKey}`;
      default:
        return '';
    }
  }
}

export default AllRolesApiConfig;
